export default __webpack_public_path__ + "static/media/hcr.23e9f3f1.png";